import { useQuery } from '@tanstack/react-query';

import { TypesenseCollection } from '../types';
import { getProjectSelectOptionByIdFromUnion } from './projects';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const PROJECT_OPTION_KEY = 'projectOption';

export const useGetProjectOptionForProjectExpenseById = (
  id: number | string | undefined,
) => {
  const _id = id && typeof id === 'string' ? id : (id?.toString() ?? undefined);

  const { data: apiKeys } = useGetTypeSenseAPIKeys();
  const projectsViewCollectionApiKey =
    apiKeys?.[TypesenseCollection.PROJECTS_VIEW.keyName]?.key ?? null;
  const projectsCollectionApiKey =
    apiKeys?.[TypesenseCollection.PROJECTS.keyName]?.key ?? null;

  const { data, ...restProps } = useQuery({
    queryKey: [
      PROJECT_OPTION_KEY,
      _id,
      projectsCollectionApiKey,
      projectsViewCollectionApiKey,
    ],
    queryFn: () =>
      getProjectSelectOptionByIdFromUnion(_id!, [
        {
          collectionName: TypesenseCollection.PROJECTS_VIEW.name,
          keyName: TypesenseCollection.PROJECTS_VIEW.keyName,
          apiKey: projectsViewCollectionApiKey!,
        },
        {
          collectionName: TypesenseCollection.PROJECTS.name,
          keyName: TypesenseCollection.PROJECTS.keyName,
          apiKey: projectsCollectionApiKey!,
        },
      ]),
    enabled:
      !!_id && !!projectsCollectionApiKey && !!projectsViewCollectionApiKey,
  });

  return { data, ...restProps };
};
